// index.js
import { initAjaxFilterShop } from './modules/ajax-filter-shop';
import { initMenu } from './modules/menu';
import { landscapeDesignTemplate} from "./modules/landscape-design-template";
import { initForms } from "./modules/forms";
import { AttributePicker } from './components/attribute-picker';
import { FiltersDrawer } from "./components/filters-drawer";
import { TabsAccordion } from "./components/tabs-accordion";

(function($) {
    $(document).ready(() => {
        // Load components
        AttributePicker.init();
        FiltersDrawer.init();
        TabsAccordion.init();

        // Initialize modules
        initAjaxFilterShop($);
        landscapeDesignTemplate($);
        initMenu($);
        initForms($);

        const $glightbox = $('[data-glightbox]');
        if (GLightbox && $glightbox.length) {
            let groups = [];

            for (let i = 0; i < $glightbox.length; i++) {
                let label = $glightbox[i].dataset.glightbox;
                if (!groups.includes(label)) groups.push(label);
            }

            const lightboxes = {}

            for (const group of groups) {
                lightboxes[group] = GLightbox({
                    selector: `[data-glightbox="${group}"]`
                });
            }
        }
    });
})(jQuery);